import React from 'react'
import PhonePage from './component/PhonePage'

const App = () => {
  return (
    <div style={{backgroundColor:'skyblue', overflow:"hidden",display:'flex',alignItems:'center', height:'100vh'}}>
        <PhonePage/>
    </div>
  )
}

export default App